
import ProductOptions from './components/ProductOptions';

export default {
  i18nComponentKey: 'WidgetProductReviewsProductOptions.WidgetProductReviewsProductOptionsPc',
  name: 'WidgetProductReviewsProductOptionsPc',
  components: { ProductOptions }
};
